export enum CrudType {
  create = 0,
  update,
  import,
  delete,
}
